var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "panel" },
    [
      _c(
        "v-row",
        [
          _c("v-col", { staticClass: "cell-full title" }, [
            _vm._v(_vm._s(_vm.instance.ativo))
          ])
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c("v-col", { staticClass: "cell-full label" }, [
            _vm._v(" Custodiante: ")
          ]),
          _c(
            "v-col",
            { staticClass: "cell-full ctrl" },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.entities,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  "item-text": "fullName",
                  "item-value": "entityId",
                  placeholder: "Entidade custodiante",
                  color: "secondary",
                  attach: "",
                  filter: _vm.filterEntity,
                  rules: [
                    function(v) {
                      return v != null || "Campo obrigatório"
                    }
                  ],
                  clearable: "",
                  required: "",
                  outlined: "",
                  rounded: "",
                  dense: ""
                },
                model: {
                  value: _vm.newEntityId,
                  callback: function($$v) {
                    _vm.newEntityId = $$v
                  },
                  expression: "newEntityId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "option" },
        [
          _c("v-col", { staticClass: "cell-50 ctrl" }, [
            _c(
              "button",
              {
                staticClass: "btn-confirm",
                attrs: { type: "button", disabled: _vm.notfilled },
                on: { click: _vm.updateEntity }
              },
              [_vm._v("Alterar")]
            )
          ]),
          _c("v-col", { staticClass: "cell-50 ctrl" }, [
            _c(
              "button",
              {
                staticClass: "btn-cancel",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v("Cancelar")]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }